import {NavigationGuardWithThis} from "vue-router";
import {useAuthStore} from "@/stores/auth";

export const authenticate: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) {
        await auth.attemptRestore();
    }
    return next();
};

export const logout: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    const auth = useAuthStore();

    await auth.logout();
    return next({ name: 'login' });
};

export const ensureAuthenticated: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    const auth = useAuthStore();

    if (auth.isAuthenticated) {
        return next();
    }

    const authenticated = await auth.attemptRestore();

    if (!authenticated) {
        if (!navigator.onLine) {
            return next({ name: 'no-connection' });
        }

        return next({ name: 'login' });
    }

    return next();
};

export const ensureNotAuthenticated: NavigationGuardWithThis<undefined> = async (to, from, next) => {
  const auth = useAuthStore();

  if (!auth.isAuthenticated) {
    await auth.attemptRestore();
  }

  if (auth.isAuthenticated) {
    return next('/tabs/home');
  }

  return next();
};

export const hasConnection: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    if (navigator.onLine || to.name === 'no-connection') {
        return next();
    }

    return next({name: 'no-connection'})
};

export const ensureEmailIsVerified: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    // const auth = useAuthStore();

    // if(auth.user?.emailVerified === true) {
    //     return next();
    // }
    return next({ name: 'verify-email' });
};

export const preventExternalAccess: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    if (!to.query.fromExternal) {
        return next();
    }

    return next({name: 'home', query: {}});
};

export const redirectBasedOnAuth: NavigationGuardWithThis<undefined> = async (to, from, next) => {
    const auth = useAuthStore();

    if (!auth.isAuthenticated) {
        await auth.attemptRestore();
    }

    if (auth.isAuthenticated) {
        return next({ path: '/tabs/home' });
    }

    return next({ name: 'login' });
};